import { jwtDecode } from "jwt-decode";

export const getUserRole = () => {
  const token = localStorage.getItem("token");
  if (!token) return "";

  try {
    const decoded = jwtDecode(token);
    return decoded.role || ""; // depende de cómo venga el rol en tu token
  } catch (error) {
    console.error("Token inválido:", error);
    return "";
  }
};
